import { createUseStyles } from 'react-jss'

const useStyles = createUseStyles({
  title: {
    fontWeight: 700
  }
})

export default useStyles
